// extracted by mini-css-extract-plugin
export default {"home-card":"HomeCard_home-card__2A7wd","card-title":"HomeCard_card-title__ByP1u","card-img":"HomeCard_card-img__frItb"};